const state = {
  currentTab: 'tab1',
  user: {},
  loggedIn: false,
  habits: [],
  logs: [],
  logsComplete: 0,
  categories: new Set(),
  selectedCategory: 'All Habits',
  selectedHabit: {},
  monthView: false,
  selectedMonth: 0,
  selectedMonthName: '',
  selectedYear: 0
}

export default state
